import './styles.scss'
import {
    IModeOfTransportationBreakdownByMonth
} from '../../../api/ModeOfTransportationBreakdownByMonth/ModeOfTransportationBreakdownByMonth.types'
import {IWidgetResponse} from '../../../api/Base/Base.types'
import {ResponsiveBar} from '@nivo/bar'
import NumberUtils from "../../../utils/number.utils";
import {Text} from "@mantine/core";
import WidgetNivoBase from "../Widget.nivo.base";

interface Props {
    data?: IWidgetResponse<IModeOfTransportationBreakdownByMonth>
}

function ModeOfTransportationBreakdownByMonth({data}: Props) {

    function getData() {
        if (data) {
            return data?.data
                .map(d => ({
                    date: `${d.month}/${d.year}`,
                    truckTotal: d.truckTotal,
                    airTotal: d.airTotal,
                    oceanTotal: d.oceanTotal,
                    railTotal: d.railTotal
                }));

        }
    }

    return (
        <div className="mode-of-transportation-breakdown-by-month">
            <WidgetNivoBase.Bar
                title="Mode Of Transportation Breakdown By Month"
                data={getData()}
                keys={["airTotal", "truckTotal", "oceanTotal", "railTotal"]}
                indexBy="date"
                axisLeftName="Totals"
                axisBottomName=""
                axisBottomRotation={-45}
                groupMode='grouped'
                colors={{"scheme": "nivo"}}
                legends={[{
                    dataFrom: "keys",
                    anchor: 'bottom',
                    direction: 'row',
                    itemWidth: 100,
                    itemHeight: 20,
                    toggleSerie: true,
                    translateY: 60
                }]}
                formatValue={v => NumberUtils.toShortened(v, 2)}
                tooltip={({value, color}) => (
                    <div style={{padding: 12, color, background: "#222222", borderRadius: 10}}>
                        <strong>{NumberUtils.numberWithCommas(value)}</strong>
                    </div>
                )}
            />
        </div>
    )
}

export default ModeOfTransportationBreakdownByMonth;